import { call, put, takeEvery } from "redux-saga/effects";
import type { PayloadAction } from "@reduxjs/toolkit";
import request from "../../../utils/request";
import { API_ENDPOINT } from "../../../utils/constants";
import { handleAxiosError } from "../../../utils/APIValidations";
import { setAuthSession } from "../../../utils/auth";
import {
  saveLogin,
  loginSaved,
  loginSavingError,
  saveGoogleLogin,
  googleLoginSaved,
  googleLoginSavingError,
} from "./slice";
import type { AuthUser, LoginPayload, GoogleLoginPayload } from "./types";

export function* postLogin({ payload }: PayloadAction<LoginPayload>) {
  const requestURL = `${API_ENDPOINT}login`;
  const options: RequestInit = {
    mode: "cors",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  try {
    const response: AuthUser = yield call(request, requestURL, options);
    setAuthSession(response);
    yield put(loginSaved(response));
  } catch (e) {
    yield call(handleAxiosError, e);
    yield put(loginSavingError());
  }
}

export function* postGoogleLogin({ payload }: PayloadAction<GoogleLoginPayload>) {
  const requestURL = `${API_ENDPOINT}login_with_google`;
  const options: RequestInit = {
    mode: "cors",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
  try {
    const response: AuthUser = yield call(request, requestURL, options);
    setAuthSession(response);
    yield put(googleLoginSaved(response));
  } catch (e) {
    yield call(handleAxiosError, e);
    yield put(googleLoginSavingError());
  }
}

export default function* saga() {
  yield takeEvery(saveLogin.type, postLogin);
  yield takeEvery(saveGoogleLogin.type, postGoogleLogin);
}
